import { useReactiveVar } from "@apollo/client";
import { ApolloStateDispatch } from "helpers/apollo-state-dispatch";
import { IApolloDispatch } from "interfaces/IApolloDispatch";
import { useMemo } from "react";
import {
  ExternalThawInternalState,
  IExternalThawInternalState,
} from "./initial-state";
import { ExternalThawInternalReducer } from "./reducer";

export function useExternalThawStateProvider(): {
  externalThawInternalState: IExternalThawInternalState;
  externalThawDispatch: IApolloDispatch<any>;
} {
  const externalThawInternalState = useReactiveVar(ExternalThawInternalState);
  const externalThawDispatch = useMemo(
    () =>
      ApolloStateDispatch(
        ExternalThawInternalState,
        ExternalThawInternalReducer
      ),
    []
  );
  return {
    externalThawInternalState,
    externalThawDispatch,
  };
}
